// extracted by mini-css-extract-plugin
export default {"signupWrapper":"styles_signupWrapper__eKAf2","signupForm":"styles_signupForm__cvH-J"};